/**
 * Fake graphql tag to enable code generation.
 */
const graphql = (strings: TemplateStringsArray, ...keys: string[]) =>
  strings.map((text, i) => (i > 0 ? keys[i - 1] : "") + text).join("");
export default graphql;
